module.exports = __webpack_public_path__ + "media/images/childcare/patricia@2x-9717fef8caa4b2681e8fdd0814affd6e.jpg";